<template>
    <div class="question-object-phonemic-consonant">
        <span class="question-object-phonemic-consonant__label">SESBİRİM</span>
        <span class="question-object-phonemic-consonant__text">/ {{ phonemicValue }} /</span>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            phonemicValue: { type: String, default: 'p' }
        }
    };
</script>

<style scoped src="@/css/components/question-object-phonemic-consonant.css"></style>